export default {
  envStr: 'devOnline',
  appName: '方舟物联网平台',
  apiHost: '/fenydata-java-gateway',
  docUrl: 'http' + '://doc.dev.fenydata.com',
}